import React, { useState } from 'react';


import Jumbotron from 'react-bootstrap/Jumbotron';
import Toast from 'react-bootstrap/Toast';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';

import Me from './me';
import About from './about';
import Contact from './contact';
import HomepageNavbar from './navbar';
import D2S2Lab from './d2s2';
import {Publications} from './publications';

import './homepage.css';


const HomepageContent = () => {
    let initialPage = "Travis Desell";

    let page = new URLSearchParams(window.location.search).get("page");
    if (page === "d2s2" || page === "D2S2") {
        initialPage = page;
    }

    let [selectedNav, setSelectedNav] = useState(initialPage);


    const updateSelectedNav = (newSelect: string):void => {
        console.log("new nav selection is: '" + newSelect + "'");
        setSelectedNav(newSelect);
    }

    if (page === "d2s2" || page === "D2S2") {
        selectedNav = "D2S2 Lab";
    }


    let content = ""

    if (selectedNav === "Travis Desell") {
        content = (
            <>
                <Me></Me>
                <Contact></Contact>
                <About></About>
            </>
        );

    } else if (selectedNav === "D2S2 Lab") {
        content = ( <D2S2Lab></D2S2Lab> );

    } else if (selectedNav === "Publications") {
        content = ( <Publications></Publications> );
    }
    

    return (
        <>
        <HomepageNavbar selectedNav={selectedNav} navbarClicked={updateSelectedNav}></HomepageNavbar>

        <Container className="p-3">
            {content}
        </Container>
        </>
        );
};

export default HomepageContent;
